export const generateId = (prefix: string = 'lc'): string => `${prefix}-${Math.random().toString(36).substring(2, 9)}`;
